import { render, staticRenderFns } from "./RightsExchangeList.vue?vue&type=template&id=3265d008&scoped=true"
import script from "./RightsExchangeList.vue?vue&type=script&lang=js"
export * from "./RightsExchangeList.vue?vue&type=script&lang=js"
import style0 from "./RightsExchangeList.vue?vue&type=style&index=0&id=3265d008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3265d008",
  null
  
)

export default component.exports